import { useIonToast } from '@ionic/react';
import { createContext, ReactElement, ReactNode } from 'react';

import { ErrorContextType } from '@typing/State';
import { IconList } from '@utils/iconUtils';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const errorContext = createContext({} as ErrorContextType);

const ValidationErrorStore = ({ children }: { children: ReactNode }): ReactElement => {
  const [present, dismiss] = useIonToast();

  const addError = (error: string) => {
    present({
      buttons: [
        {
          handler: () => {
            window.open('mailto: support@withgrayce.com');
          },
          icon: IconList.questionCircle
        },
        { handler: () => dismiss(), icon: IconList.xmark }
      ],
      color: 'danger',
      cssClass: 'toast',
      duration: 5000,
      message: error,
      position: 'top'
    });
  };

  return (
    <errorContext.Provider
      value={{
        addError
      }}
    >
      {children}
    </errorContext.Provider>
  );
};

export default ValidationErrorStore;
